module.exports = __webpack_public_path__ + "img/spribe.07272132.jpg";